var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_499_1427)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_499_1427)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_499_1427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 4H9C6.23858 4 4 6.23858 4 9V31C4 33.7614 6.23858 36 9 36H31C33.7614 36 36 33.7614 36 31V9C36 6.23858 33.7614 4 31 4Z",
    fill: "#04BF96"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_499_1427",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7178 11.5293H12.4707V26.7764H27.7178V11.5293Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_499_1427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4223 20.2147L20.4274 20.1909C20.5261 19.7842 20.6504 19.277 20.5534 18.8176C20.4887 18.4551 20.2215 18.3139 19.9935 18.3037C19.7247 18.2918 19.4847 18.4449 19.4252 18.6678C19.3128 19.0763 19.4132 19.6344 19.597 20.3457C19.3656 20.897 18.9963 21.6985 18.7258 22.175C18.2221 22.4354 17.5465 22.837 17.4461 23.3441C17.4257 23.4377 17.4495 23.5568 17.5057 23.664C17.5686 23.7831 17.669 23.875 17.7864 23.9192C17.8375 23.938 17.8988 23.9533 17.9702 23.9533C18.2697 23.9533 18.7547 23.7116 19.4013 22.6021C19.5 22.5698 19.6021 22.5358 19.7008 22.5017C20.1637 22.3452 20.6436 22.1818 21.0775 22.1086C21.5574 22.3656 22.1036 22.5307 22.4746 22.5307C22.8421 22.5307 22.9868 22.3128 23.0412 22.1818C23.1365 21.9521 23.0906 21.6628 22.9357 21.508C22.7111 21.2867 22.1649 21.2289 21.314 21.3344C20.8954 21.0791 20.6214 20.732 20.4223 20.2147ZM18.5556 22.7995C18.3191 23.1433 18.1404 23.3151 18.0434 23.39C18.1574 23.1807 18.3803 22.9595 18.5556 22.7995ZM20.0463 18.7921C20.1348 18.9435 20.1228 19.4013 20.0548 19.6327C19.9714 19.2941 19.9595 18.8142 20.0088 18.758C20.0225 18.7597 20.0344 18.7699 20.0463 18.7921ZM20.019 20.8426C20.2011 21.1574 20.4309 21.428 20.6844 21.6288C20.3168 21.7122 19.9816 21.85 19.6821 21.9725C19.6106 22.0014 19.5409 22.0304 19.4728 22.0576C19.6991 21.6475 19.888 21.1829 20.019 20.8426ZM22.6669 21.9572C22.6686 21.9606 22.6703 21.9657 22.6601 21.9725H22.6567L22.6532 21.9776C22.6396 21.9861 22.5001 22.0678 21.8994 21.8313C22.5903 21.7989 22.6652 21.9555 22.6669 21.9572ZM25.9239 15.3513L22.2619 11.6892C22.1598 11.5871 22.0219 11.5293 21.8773 11.5293H14.6485C14.3473 11.5293 14.104 11.7726 14.104 12.0738V26.2318C14.104 26.533 14.3473 26.7764 14.6485 26.7764H25.5393C25.8405 26.7764 26.0838 26.533 26.0838 26.2318V15.7376C26.0838 15.5929 26.026 15.4534 25.9239 15.3513ZM24.828 15.9877H21.6254V12.7851L24.828 15.9877ZM24.8586 25.5511H15.3292V12.7545H20.4683V16.4301C20.4683 16.6197 20.5436 16.8015 20.6776 16.9355C20.8117 17.0695 20.9934 17.1448 21.183 17.1448H24.8586V25.5511Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_499_1427",
    x: 0,
    y: 4,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_499_1427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_499_1427",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_499_1427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_499_1427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportPdf);
export default __webpack_public_path__ + "static/media/export-pdf.e5dadf9562bda6973717c17bb852e4cc.svg";
export { ForwardRef as ReactComponent };